module.exports = __webpack_public_path__ + "img/mockup-popvalet-1.8b5c1ec7.png";